var map = {
  "./": "55672",
  "./bulk_create": "1123",
  "./bulk_create.js": "1123",
  "./bulk_delete": "31354",
  "./bulk_delete.js": "31354",
  "./bulk_edit": "59122",
  "./bulk_edit.js": "59122",
  "./edit": "71664",
  "./edit.js": "71664",
  "./index": "55672",
  "./index.js": "55672",
  "./new": "42881",
  "./new.js": "42881",
  "./show": "52601",
  "./show.js": "52601",
  "./tabs": "44686",
  "./tabs.js": "44686"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 14932;
